import type { SentryTeamNames } from '@frontend/sentry-teams';

export const DEFAULT_ROUTE_TEAM: SentryTeamNames = 'frontend-ops';

type RouteMatchWithTeam = {
  staticData: {
    team?: SentryTeamNames;
  };
};

export const resolveRouteTeam = (matches: readonly RouteMatchWithTeam[]): SentryTeamNames => {
  for (let index = matches.length - 1; index >= 0; index--) {
    const team = matches[index].staticData.team;

    if (team) return team;
  }

  return DEFAULT_ROUTE_TEAM;
};
